/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IUserCredentialAuthenticationRequest {
  password?: null | string;
  scope?: null | Array<string>;
  username?: null | string;
}
export class UserCredentialAuthenticationRequest extends BaseModel implements IUserCredentialAuthenticationRequest {
  password?: null | string;
  scope?: null | Array<string>;
  username?: null | string;
}

